import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// ignore-string-externalization
import "@spotify-internal/encore-web/css/fonts.css";
import "@apps/artists-spotify-com-c/src/shared/styles/global.scss";
import "@spotify-internal/react-dates/lib/css/_datepicker.css";
import "@apps/artists-spotify-com-c/src/shared/styles/react-dates.scss";
import React, { useEffect } from "react";
import dynamic from "next/dynamic";
import Head from "next/head";
import { appWithI18n } from "@mrkt/features/i18n/appWithI18n";
import { LanguageHead } from "@mrkt/features/i18n/components/LanguageHead";
import { MrktAppLanguageLogger } from "@mrkt/features/i18n/components/MrktAppLanguageLogger";
import { appWithCssTransform } from "@mrkt/features/css/appWithCssTransform";
import { App } from "@mrkt/features/next";
import { AppTheme } from "@mrkt/features/encore-theme/creator";
import { withReactRouter } from "../lib/withReactRouter";
import { startAxeOverlay } from "@mrkt/features/start-axe-overlay";
import { track } from "@spotify-internal/track-js";
import { isWebView } from "@mrkt/features/isWebView";
// client-side only
if (process.browser) {
    require("@apps/artists-spotify-com-c/src/setup/polyfill");
    require("@apps/artists-spotify-com-c/src/init");
}
var S4AApp = dynamic(function() {
    return import(/* webpackChunkName: "app" */ "@apps/artists-spotify-com-c/src/app").then(function(mod) {
        return mod.App;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                require.resolveWeak("@apps/artists-spotify-com-c/src/app")
            ];
        }
    },
    ssr: false
});
function CustomApp(props) {
    useEffect(function() {
        startAxeOverlay();
    }, []);
    useEffect(function() {
        if (!isWebView) track({
            market: "not_set",
            googleTagManagerId: "production" === "production" ? "GTM-NP2G964" : undefined,
            oneTrust: // ignore cookie banner in synthetic tests for now
            !navigator.webdriver && // cookie is only set on *.spotify.com
            window.location.host.endsWith(".spotify.com")
        });
    }, []);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(LanguageHead, {
                base: "https://artists.spotify.com"
            }),
            /*#__PURE__*/ _jsxs(Head, {
                children: [
                    /*#__PURE__*/ _jsx("meta", {
                        name: "viewport",
                        content: "width=device-width, initial-scale=1, shrink-to-fit=no"
                    }),
                    /*#__PURE__*/ _jsx("title", {
                        children: process.env.REACT_APP_TITLE
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(AppTheme, _object_spread_props(_object_spread({}, props), {
                children: /*#__PURE__*/ _jsx(S4AApp, {
                    children: /*#__PURE__*/ _jsx(App, _object_spread({}, props))
                })
            })),
            /*#__PURE__*/ _jsx(MrktAppLanguageLogger, {})
        ]
    });
}
export default appWithCssTransform(appWithI18n(withReactRouter(CustomApp)));
export { reportWebVitals } from "@mrkt/features/metrics";
